import { ICellRendererParams } from "ag-grid-community";
import moment from "moment";
import DayPartingSlotPopover from "@modals/day-parting-modal/DayPartingSlotPopover";
import { CAMPAIGN_SYNC_STATE, TAllSlots } from "@ts/common-types";
import useCampaignSyncCheck from "@/hooks/useCampaignSyncCheck";
import { useMemo } from "react";

const ActionCellRenderer = (params: ICellRendererParams) => {
    let automationIconColor;
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const dprTimezone =
        params.data.dpr_timezone !== null
            ? params.data.dpr_timezone
            : currentTimezone;

    const currentTime = moment(
        new Date().toLocaleString("en-US", { timeZone: dprTimezone }),
        "M/D/YYYY, h:mm:ss A"
    );
    const currentDayIndex = (
        currentTime.day() === 0 ? 7 : currentTime.day()
    ).toString();
    // const currentTimeString = currentTime.format("HH:mm");

    const currentDayDprSlots =
        params.data.all_dpr_slots &&
            currentDayIndex in params.data.all_dpr_slots
            ? [...params.data.all_dpr_slots[currentDayIndex].slots]
            : [];

    const isDprRunning =
        params.data.all_dpr_slots &&
            currentDayIndex in params.data.all_dpr_slots
            ? params.data.all_dpr_slots[currentDayIndex].isDprApplied
            : false;

    const allAvailableSlots = params.data.all_dpr_slots
        ? Object.values(params.data.all_dpr_slots)
        : [];

    const isAllSlotsDisabled = () => {
        const isDprEnabled: boolean[] = [];
        const allSlots: TAllSlots[] =
            params.data.all_dpr_slots && params.data.all_dpr_slots !== null
                ? Object.values(params.data.all_dpr_slots)
                : [];
        allSlots.forEach((slot) => {
            if (slot.state) isDprEnabled.push(true);
            else isDprEnabled.push(false);
        });

        return isDprEnabled.filter((state) => state === true).length !== 0
            ? false
            : true;
    };

    currentDayDprSlots.length === 0 && allAvailableSlots.length === 0
        ? (automationIconColor = "grey")
        : isAllSlotsDisabled() === true
            ? (automationIconColor = "red")
            : isDprRunning
                ? (automationIconColor = "green")
                : (automationIconColor = "blue");

    const { isCampaignSyncCheckRequired } = useCampaignSyncCheck({ params });

    const isActionCellDisabled = useMemo(() => {
        let disabledState = false;
        if (isCampaignSyncCheckRequired) {
            const isPending = params.data.sync_state === CAMPAIGN_SYNC_STATE.PENDING;
            disabledState = isPending || !!disabledState;
        }
        return disabledState;
    }, [isCampaignSyncCheckRequired, params]);


    return (
        <>
            <div style={{
                textAlign: "center", ...(isActionCellDisabled ? {
                    opacity: 0.5,
                    pointerEvents: "none",
                } : {})
            }}>
                {isAllSlotsDisabled()}
                <DayPartingSlotPopover
                    params={params}
                    automationIconColor={automationIconColor}
                />
            </div>
        </>
    );
};

export default ActionCellRenderer;
